<script setup lang="ts">
  import type { IconName } from '@/types';
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon.vue';
  import { computed } from 'vue';

  defineOptions({ name: 'ContentWithIcon' });

  const { text = '', icon } = defineProps<{ text?: string; icon: IconName }>();
  const isMultiline = computed<boolean>(() => text.includes('\n'));
</script>

<template>
  <div
    class="content-with-icon flex flex-row gap-4"
    :class="[isMultiline ? 'items-start' : 'items-center']"
  >
    <SvgIcon
      class="flex-none"
      size="larger"
      :icon="icon"
    />
    <span class="max-wrap whitespace-pre-line">
      <template v-if="!$slots.default">
        {{ text }}
      </template>
      <slot v-else />
    </span>
  </div>
</template>
